export function submitAnswer(state, payload) {
  return {
    ...state,
    currentChapter: updateSubmitInCurrentChapter(state.currentChapter, payload),
  };
}

function updateSubmitInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: updateSubmitInComponents(currentChapter.components, payload),
  };
}

/**
 *
 * @param {'Array<Object>'} components array of components
 * @param {'number'} payload component ID
 * @returns
 */
function updateSubmitInComponents(components, payload) {
  return components.map((component) => {
    if (component.id === payload) {
      component = updateSubmitInDDQComponent(component);
    }
    return component;
  });
}

function updateSubmitInDDQComponent(ddqComponent) {
  if (ddqComponent.totalAttempts === -10 || ddqComponent.totalAttempts > 0) {
    const setShowFeedbackTrue = (step) => ({ ...step, showFeedback: true });
    const answerSteps = ddqComponent.answerSteps.map(setShowFeedbackTrue);
    const totalAttempts =
      ddqComponent.totalAttempts === -10 ? -10 : ddqComponent.totalAttempts - 1;
    const complete = setDDQComplete(answerSteps, totalAttempts);
    return {
      ...ddqComponent,
      complete,
      answerSteps,
      totalAttempts,
    };
  } else {
    return {
      ...ddqComponent,
      complete: true,
      totalAttempts: 0,
    };
  }
}

function setDDQComplete(answerSteps, totalAttempts) {
  if (totalAttempts === -10 || totalAttempts >= 1) {
    return answerSteps.reduce((boolValue, step) => {
      if (step.value !== step.droppedId) {
        boolValue = false;
      }
      return boolValue;
    }, true);
  } else {
    return true;
  }
}
